// extracted by mini-css-extract-plugin
module.exports = {"content":"ProjectSafeDeal_content_2nnCj","footer":"ProjectSafeDeal_footer_3W4dp"};